import { useAuth } from '@/shared/context'
import { useAppDispatch } from '@/shared/redux/hooks'
import {
  getListSystemKey,
  setAppInitialized,
  setListTabs,
  setUserInfo,
} from '@/shared/redux/slices/appGlobal.slice'
import CommonService from '@/shared/services/CommonService'
import IdentityService from '@/shared/services/IdentityService'
import { STORAGE, getLocalStorage, isLoggedIn, setLocalStorage } from '@/shared/utils/storage'
import { type ReactNode, useEffect } from 'react'

interface DefaultActionProps {
  children?: ReactNode
}

const DefaultAction = ({ children }: DefaultActionProps) => {
  const isLogin = isLoggedIn()

  const { setUser } = useAuth()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const initializeApp = async () => {
      const initPromises = []

      // 1. System Key Promise (always load)
      const systemKeyPromise = (async () => {
        try {
          const res = await CommonService.getSystemKey()
          if (!res.isError) {
            dispatch(getListSystemKey(res.object))
          }
        } catch (_error) {
          console.error('DefaultAction>>getSystemKey error:', _error)
        }
      })()
      initPromises.push(systemKeyPromise)

      // 2. Auth-related Promises (only load if user is logged in)
      if (isLogin) {
        setLocalStorage(
          STORAGE.DEV_MODE,
          !!(typeof window !== 'undefined' && (window as any).env?.API_ROOT)?.IS_DEV
        )

        const getListTabPromise = (async () => {
          try {
            const resp = await IdentityService.getTabs()
            if (resp.isOk) {
              dispatch(
                setListTabs([
                  {
                    categoryId: 0,
                    Description: 'Tổng Quan',
                    isVisitTab: true,
                  },
                  {
                    categoryId: -1,
                    codeKey: 'MyTicket',
                    description: 'MyTicket',
                    isVisitTab: true,
                  },
                  ...resp.object,
                ])
              )
            }
          } catch (_error) {
            console.error('DefaultAction>>getListTab error:', _error)
          }
        })()
        initPromises.push(getListTabPromise)

        // ponytail: BE không có route getInfo tương ứng — login đã lưu đủ user info vào
        // STORAGE.USER_INFO (xem use-login.ts), đọc lại từ đó thay vì gọi API thừa
        const userInfo = getLocalStorage(STORAGE.USER_INFO)
        if (userInfo) {
          dispatch(setUserInfo(userInfo))
          setUser(userInfo)
        }
      }

      // 3. Minimum 2.5s delay
      const timerPromise = new Promise((resolve) => setTimeout(resolve, 2500))

      // Wait for everything to settle
      await Promise.allSettled([...initPromises, timerPromise])

      // Initialize finished
      dispatch(setAppInitialized(true))
    }

    initializeApp()
  }, [dispatch, isLogin, setUser])

  // ponytail: SignalR car-detection notification wiring removed with qlrv features; no TXNG equivalent yet
  return <>{children}</>
}

export default DefaultAction
